import { useMemo } from 'react';

import { useAbExperimentBucket } from 'hooks/abExperiment/useAbExperimentBucket';
import { LocaleFacet } from 'modules/search/components/Facet/LocaleFacet';
import { LocationTypeFacet } from 'modules/search/components/Facet/LocationTypeFacet';
import { OrgAreasOfFocusFacet } from 'modules/search/components/Facet/OrgAreasOfFocusFacet';
import { OrgTypeFacet } from 'modules/search/components/Facet/OrgTypeFacet';
import { RadiusFacet } from 'modules/search/components/Facet/RadiusFacet';
import { RecencyFacet } from 'modules/search/components/Facet/RecencyFacet';
import { SearchRefinements } from 'modules/search/components/Refinements/SearchRefinements';

import { InternshipKeywordsFacet } from './InternshipKeywordsFacet';
import { PaymentFacet } from './PaymentFacet';

export function SearchInternshipRefinements() {
  const [bucketValue] = useAbExperimentBucket('NEW_SEARCH_2025_03');

  const refinementsByLocale = useMemo(
    () => ({
      en: [
        <LocationTypeFacet />,
        <InternshipKeywordsFacet />,
        <OrgAreasOfFocusFacet />,
        <OrgTypeFacet />,
        <PaymentFacet />,
        <LocaleFacet />,
        <RecencyFacet />,
        <RadiusFacet />,
      ],
      es: [
        <LocationTypeFacet />,
        <InternshipKeywordsFacet />,
        <LocaleFacet />,
        <OrgAreasOfFocusFacet />,
        <RecencyFacet />,
        <PaymentFacet />,
        <OrgTypeFacet />,
        <RadiusFacet />,
      ],
      pt: [
        <LocationTypeFacet />,
        <InternshipKeywordsFacet />,
        <OrgAreasOfFocusFacet />,
        <LocaleFacet />,
        <PaymentFacet />,
        <RecencyFacet />,
        <OrgTypeFacet />,
        <RadiusFacet />,
      ],
    }),
    [],
  );

  return bucketValue === 'ENABLED' ? (
    <SearchRefinements listingType="INTERNSHIP">
      {refinementsByLocale[CURRENT_LOCALE()]}
    </SearchRefinements>
  ) : null;
}
